// src/pages/News/News.tsx
import React, { useState, useEffect } from 'react';
import Page from '../../layouts/Page';
import Grid from '../../components/Grid';
import styles from './styles.module.sass';
import { hostname } from '../../constants';

const News: React.FC = () => {
  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    fetch(`${hostname}/wp-json/wp/v2/news?per_page=100`)
      .then(res => res.json())
      .then((news: any[]) => setData(news))
      .catch(console.error);
  }, []);

  if (data.length === 0) return null;

  return (
    <Page className={styles.base}>
      <Grid data={data} />
    </Page>
  );
};

export default News;
